module.exports = __webpack_public_path__ + "img/trips-3-mobile.d3257ba3.gif";